
export const downloadPdfFile = (response, filename) => {
    let blob = new Blob([response], { type: 'application/pdf' });
    let url = window.URL.createObjectURL(blob);
    if (url) {
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
}

export const downLoadImageFile = (response, filename) => {
    let blob = new Blob([response], { type: 'image/jpeg' });
    let url = window.URL.createObjectURL(blob);
    if (url) {
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
}

export const previewPdf = (buffer)=>{
    let blob = new Blob([buffer], { type: "application/pdf" });
    let fileURL = window.URL.createObjectURL(blob);
    window.open(fileURL);
}
export const previewImage = (buffer)=>{
    let blob = new Blob([buffer], { type: "image/jpeg" });
    let fileURL = window.URL.createObjectURL(blob);
    window.open(fileURL);
}


